var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Announcement",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "120px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.title,
      callback: function ($$v) {
        _vm.$set(_vm.item, "title", $$v);
      },
      expression: "item.title"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Tag",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.tag,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tag", $$v);
      },
      expression: "item.tag"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Content",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: _vm.item.content,
      callback: function ($$v) {
        _vm.$set(_vm.item, "content", $$v);
      },
      expression: "item.content"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Image"
    }
  }, [_vm.item.image_url ? _c('img', {
    attrs: {
      "src": _vm.item.image_url,
      "height": "100px",
      "width": "auto"
    }
  }) : _vm._e(), _c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.item.image_url,
      callback: function ($$v) {
        _vm.$set(_vm.item, "image_url", $$v);
      },
      expression: "item.image_url"
    }
  }), _c('el-upload', {
    attrs: {
      "on-success": _vm.onUploadSuccess,
      "data": _vm.data,
      "headers": _vm.headers,
      "accept": "image/*",
      "action": _vm.action,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("Upload")])], 1), _vm.item.image_url ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "default"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Remove")]) : _vm._e()], 1), _c('el-form-item', {
    attrs: {
      "label": "CTA"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.cta,
      callback: function ($$v) {
        _vm.$set(_vm.item, "cta", $$v);
      },
      expression: "item.cta"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "CTA Url"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.cta_url,
      callback: function ($$v) {
        _vm.$set(_vm.item, "cta_url", $$v);
      },
      expression: "item.cta_url"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Publish?"
    }
  }, [_c('el-checkbox', {
    model: {
      value: _vm.item.is_published_as_draft,
      callback: function ($$v) {
        _vm.$set(_vm.item, "is_published_as_draft", $$v);
      },
      expression: "item.is_published_as_draft"
    }
  }, [_vm._v("Publish as draft for admins")]), _c('el-checkbox', {
    model: {
      value: _vm.item.is_published,
      callback: function ($$v) {
        _vm.$set(_vm.item, "is_published", $$v);
      },
      expression: "item.is_published"
    }
  }, [_vm._v("Publish announcement")])], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }